export default {
  'isSure': 'Are you sure you want to exit the system?',
  'tips': 'Reminder'
}
